import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { SKILLS } from '../constants';

const TechSection = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background-color: var(--color-portfolio-ink);
  color: var(--color-portfolio-silver-light);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: clamp(2rem, 4vw, 4rem);
  box-sizing: border-box;
  overflow-y: auto;
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: clamp(1.5rem, 3vh, 2.5rem);
  border-bottom: 1px solid rgba(117, 22, 40, 0.3);
  padding-bottom: 1rem;
`;

const SectionTag = styled.span`
  font-family: var(--font-portfolio-mono);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--color-portfolio-wine-light);
`;

const Title = styled.h2`
  font-family: var(--font-portfolio-display);
  font-size: clamp(2.5rem, 5vw, 4.2rem);
  font-weight: 800;
  line-height: 0.9;
  letter-spacing: -0.03em;
  text-transform: uppercase;
  margin: 0;

  span {
    color: var(--color-portfolio-wine);
  }
`;

const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }
`;

const SkillCategoryCard = styled(motion.div)`
  background: var(--color-portfolio-ink-card);
  border: 1px solid rgba(117, 22, 40, 0.3);
  border-top: 3px solid var(--color-portfolio-wine);
  border-radius: 8px;
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
`;

const CategoryTitle = styled.h3`
  font-family: var(--font-portfolio-display);
  font-size: 1.5rem;
  color: var(--color-portfolio-silver-light);
  margin: 0;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

const PillsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const SkillPill = styled.span`
  font-family: var(--font-portfolio-mono);
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--color-portfolio-silver);
  background: rgba(117, 22, 40, 0.12);
  border: 1px solid rgba(117, 22, 40, 0.3);
  padding: 0.45rem 0.85rem;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--color-portfolio-wine);
    color: var(--color-portfolio-silver-light);
    border-color: var(--color-portfolio-wine);
    transform: translateY(-2px);
  }
`;

const TechStack = () => {
  return (
    <TechSection id="skills">
      <SectionHeader>
        <SectionTag>04 // Toolbelt</SectionTag>
        <Title>
          Tech <span>Stack</span>
        </Title>
      </SectionHeader>

      <SkillsGrid>
        {SKILLS.map((cat, idx) => (
          <SkillCategoryCard
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: idx * 0.1 }}
          >
            <CategoryTitle>{cat.category}</CategoryTitle>
            <PillsWrapper>
              {cat.skills.map((skill, sIdx) => (
                <SkillPill key={sIdx}>{skill}</SkillPill>
              ))}
            </PillsWrapper>
          </SkillCategoryCard>
        ))}
      </SkillsGrid>
    </TechSection>
  );
};

export default TechStack;
